"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ModalContent = _interopRequireDefault(require("./ModalContent"));

// Libraries
// Components
var Modal =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(Modal, _React$Component);

  function Modal() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, Modal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(Modal)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      isOpen: _this.props.initialIsOpen
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleOpen", function () {
      _this.setState({
        isOpen: true
      }, function () {
        if (_this.props.onOpen) {
          _this.props.onOpen();
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleClose", function () {
      _this.setState({
        isOpen: false
      }, function () {
        if (_this.props.onClose) {
          _this.props.onClose();
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleRequestOpen", function () {
      // We need to open on the next event so the setState
      // isn't batched with clicking on the overlay to close.
      setTimeout(_this.handleOpen, _this.props.openDelay);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleRequestClose", function () {
      _this.handleClose();
    });
    return _this;
  }

  (0, _createClass2["default"])(Modal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          trigger = _this$props.trigger,
          children = _this$props.children;
      var isOpen = this.state.isOpen;
      return _react["default"].createElement(_react["default"].Fragment, null, trigger({
        isOpen: isOpen,
        handleOpen: this.handleRequestOpen
      }), _react["default"].createElement(_ModalContent["default"], {
        isOpen: isOpen,
        onClose: this.handleRequestClose
      }, children({
        isOpen: isOpen,
        handleClose: this.handleRequestClose
      })));
    }
  }]);
  return Modal;
}(_react["default"].Component); // --------------------------------------------------
// Props
// --------------------------------------------------


Modal.propTypes = {
  trigger: _propTypes["default"].func.isRequired,
  initialIsOpen: _propTypes["default"].bool,
  openDelay: _propTypes["default"].number,
  onOpen: _propTypes["default"].func,
  onClose: _propTypes["default"].func
};
Modal.defaultProps = {
  initialIsOpen: false,
  openDelay: 200,
  onOpen: function onOpen() {},
  onClose: function onClose() {}
};
Modal.Content = _ModalContent["default"];
var _default = Modal;
exports["default"] = _default;